const shadow = {
  light: '#778899',
  dark: '#778899',
};

export { shadow };
